import SectorKeenSlider from './SectorKeenSlider'

import fetchWithTimeout from '@/lib/utils/fetch-with-timeout'

export default async function SectorSlider({ title, text }: { title?: string; text?: string }) {
  const fields = [
    'id',
    'slug',
    'title',
    'link',
    'menu_order',
    'parent',
    'template',
    'acf.hide_from_search',
    'acf.grid_image',
  ]

  const fieldsParam = fields.map((field) => `_fields[]=${field}`).join('&')

  const url = `${process.env.NEXT_PUBLIC_WP_API_URL}/wp-json/wp/v2/all-sectors?per_page=100&parent=0&orderby=menu_order&order=asc&${fieldsParam}`

  const response = (await fetchWithTimeout(url)) as Response

  const data = await response.json()

  if (!data || !data.length) {
    return null
  }

  // Remove market-specific "AB Test" posts from results
  const filteredData = data.filter((post) => {
    return (
      (!post?.template || !post.template.includes('template-market-sectors.php')) &&
      post?.acf?.hide_from_search !== true
    )
  })

  return (
    <div className="component component--sector-slider">
      <div className="container">
        <h2 className="mb-l">{title}</h2>
      </div>

      <div className="container [@media(max-width:1000px)]:pr-0">
        <SectorKeenSlider posts={filteredData} title={title} text={text} />
      </div>
    </div>
  )
}
